import { render, staticRenderFns } from "./Filtres.vue?vue&type=template&id=60b51240&"
import script from "./Filtres.vue?vue&type=script&lang=js&"
export * from "./Filtres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports